export default __webpack_public_path__ + "static/21-f9b2cef524096c4c8030a0f92d1ece99.webp";